import clsx from 'clsx'
import { Typography } from '../../common/typography'
import { SeasonStats } from '../../races/api'
import classes from './PerformanceOverview.module.css'
import { useMediaQuery } from '@mantine/hooks'

export default function RacesPerformanceOverview({
  title,
  stats,
}: {
  title?: string
  stats: SeasonStats
}) {
  const isMobile = useMediaQuery('(max-width: 799px)')

  return (
    <div className={classes.container}>
      {title && (
        <Typography
          level={3}
          fs="xl"
          fw={500}
          fc={{ light: 'black', dark: 'gray-3' }}
          lh="100"
          tt="capitalize"
        >
          {title}
        </Typography>
      )}

      <div className={classes.data_wrapper} data-mobile={isMobile}>
        <div className={classes.stats_wrapper} data-mobile={isMobile}>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ta="center"
              lh="125"
              className={classes.race_stat_box}
            >
              Starts
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.starts}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-1' }}
              ta="center"
              lh="125"
              className={clsx(classes.wins, classes.race_stat_box)}
            >
              Wins
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.wins}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-1' }}
              ta="center"
              lh="125"
              className={clsx(classes.top3, classes.race_stat_box)}
            >
              Top 3
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.top_3}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-3' }}
              ta="center"
              lh="125"
              className={clsx(classes.top5, classes.race_stat_box)}
            >
              Top 5
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.top_5}
            </Typography>
          </div>
          <div className={classes.stat_box}>
            <Typography
              fw={500}
              fc={{ light: 'white', dark: 'gray-3' }}
              ta="center"
              lh="125"
              className={clsx(classes.outpaced, classes.race_stat_box)}
            >
              Outpaced
            </Typography>
            <Typography
              fw={500}
              fc={{ light: 'black', dark: 'gray-3' }}
              ff="JetBrains Mono"
              ta="center"
              lh="150"
            >
              {stats.starts - stats.top_5}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}
